"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentProductAllOfToJSON = exports.ShipmentProductAllOfFromJSONTyped = exports.ShipmentProductAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ShipmentProductAllOfFromJSON(json) {
    return ShipmentProductAllOfFromJSONTyped(json, false);
}
exports.ShipmentProductAllOfFromJSON = ShipmentProductAllOfFromJSON;
function ShipmentProductAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'articleNumber': json['articleNumber'],
        'aplus': !(0, runtime_1.exists)(json, 'aplus') ? undefined : (json['aplus'].map(_1.ShipmentProductAllOfAplusFromJSON)),
    };
}
exports.ShipmentProductAllOfFromJSONTyped = ShipmentProductAllOfFromJSONTyped;
function ShipmentProductAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'articleNumber': value.articleNumber,
        'aplus': value.aplus === undefined ? undefined : (value.aplus.map(_1.ShipmentProductAllOfAplusToJSON)),
    };
}
exports.ShipmentProductAllOfToJSON = ShipmentProductAllOfToJSON;
//# sourceMappingURL=ShipmentProductAllOf.js.map